var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sb-412"},[(_vm.allowContent)?_c('div',{staticClass:"container-41"},[_c('button',{staticClass:"close-btn",attrs:{"type":"button"},on:{"click":_vm.onClose}},[_vm._v("X")]),_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }